import React,{ useEffect, useState } from "react"
import { useHourlyActiveUser } from "../../hooks/useHourlyActiveUser"
import moment from "moment"
import _ from 'lodash'
import ReactECharts from 'echarts-for-react';
import active_user_bg from './img/active_user.svg'
import * as echarts from 'echarts/core';
import { blue } from "../../theme/colors";
import { useHitRate } from "../../hooks/useHitRate";
// import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import advantage from './img/advantage.svg'
import tile_bg from './img/tile_bg.svg'
import tile_bg_1 from './img/tile_bg_1.svg'
import tile_bg_2 from './img/tile_bg_2.svg'
import tile_bg_3 from './img/tile_bg_3.svg'
import tile_bg_4 from './img/tile_bg_4.svg'
import Spacer from "../../components/Spacer";
import rank_bg from './img/rank_bg.svg'
import ranking_logo from './img/ranking_logo.svg'

import crown1 from './img/crown_1.svg'
import crown2 from './img/crown_2.svg'
import crown3 from './img/crown_3.svg'
import { useTopPlanner } from "../../hooks/useDraw";
import { base } from "../../hooks/usePlanners";
import { useTranslation } from "react-i18next";
const crowns = [crown1,crown2,crown3]

const Head:React.FC<{tileHead?:string,title?:string,crown?:string,description?:string,ringColor?:string,textColor?:string,ringShadow?:string}> = ({crown,textColor,ringShadow,ringColor,tileHead,title,description})=>{
  const [profileHeight,setProfileHeight] = useState()
  return <div style={{position:'relative'}}>
    <div style={{display:'flex',flexDirection:'column',alignItems:'center',}}> 
      <div style={{alignSelf:'center',position:'relative',width: profileHeight?(profileHeight+2):'50%',height:profileHeight?(profileHeight+2):'auto', display:'flex',borderWidth:2,borderRadius:100,boxShadow:ringShadow,borderColor:ringColor||'white',overflow:'hidden'}}>
        <img onLoad={e=>{
          // @ts-ignore
          console.log('onLoad',e.target.width)
          if(!profileHeight){
            // @ts-ignore
            setProfileHeight(e.target.width)
          }
        }}  style={{width:profileHeight || '100%',aspectRatio:1/1,height:profileHeight||'auto'}}   src={tileHead||'https://wingo.oss-ap-southeast-7.aliyuncs.com/avatar/9.jpeg'}/>
      </div>
      <img src={crown} style={{position:'absolute',left:'0%',top:'-5%',width:'40%'}}/>
      <div style={{marginTop:'60%',fontWeight:'bold',fontSize:15,marginLeft:10,marginRight:10,color:textColor,textAlign:'center'}}>
      {title}
      </div>
      <div style={{marginLeft:10,fontSize:12,marginRight:10,color:textColor}}>
      {description}
      </div>
    </div>
  </div>
}
export const WinningRanks = ()=>{
    
    const {data:planners,refresh:loadTopPlanner} = useTopPlanner()
    useEffect(()=>{
      loadTopPlanner()
    },[])
    const {t} = useTranslation()
    if(!planners){
      return <></>
    }
    return <div style={{alignSelf:'stretch',position:'relative'}}>
      <div style={{display:'flex',flexDirection:'row',alignItems:'center',marginTop:10,fontWeight:'bold'}}> 
        <img src={ranking_logo} style={{width:20,height:20,marginLeft:10,marginRight:10}}/>{t('Winning Rankings')}
      </div>  
      <div style={{alignSelf:'stretch',backgroundColor:'white', padding:10,borderRadius:10,margin:10,boxShadow:'0px 6px 12px rgba(0, 0, 0, 0.08)',paddingBottom:10}}>
       
        <img src={rank_bg} style={{width:'100%',marginTop:'10%'}}/>   
        <div style={{display:'flex',flexDirection:'row',marginTop:'-46%',}}>
          <div style={{flex:2,display:'flex',alignItems:'center',justifyContent:'center',paddingTop:'10%'}}>
            <div style={{textAlign:'center'}}>
              <Head crown={crowns[1]} tileHead={base+'avatar/'+planners?.[1].pid.replace('planner','')+'.jpeg'} ringColor="#F5E5FF" textColor="#D388FF" ringShadow="0px 12px 20px rgba(148, 73, 192, 0.3)" title={planners?.[1].plannerName} description={(planners?.[1].hitsCount*10)+'%'}/>
            </div> 
          </div>
          <div style={{flex:2.5,display:'flex',alignItems:'flex-start',justifyContent:'center'}}>
            <span style={{textAlign:'center'}}>
              <Head crown={crowns[0]} tileHead={base+'avatar/'+planners?.[0].pid.replace('planner','')+'.jpeg'} ringColor={'#E7EFFF'} textColor="#3478FE" ringShadow="0px 12px 30px rgba(102, 153, 255, 0.3)" title={planners?.[0].plannerName} description={(planners?.[0].hitsCount*10)+'%'}/>
            </span>
          </div>
          <div style={{flex:2,display:'flex',alignItems:'center',justifyContent:'center',paddingTop:'10%'}}>
            <span style={{textAlign:'center'}}>
              <Head crown={crowns[2]} tileHead={base+'avatar/'+planners?.[2].pid.replace('planner','')+'.jpeg'} ringColor="#FFE7D9" textColor="#FF772A" ringShadow="0px 12px 20px rgba(255, 108, 71, 0.2)" title={planners?.[2].plannerName} description={(planners?.[2].hitsCount*10)+'%'}/>
            </span>
          </div>
        </div>
      </div>
      
    </div>
  }